const BASE_TRACKING_LINK_NAME = '[Sporting Life Video]';
const TRACKING_EVENT = 'linkClick';

const makePlayerEventTracker = (context) => (eventName, response) => {
  if (eventName === 'initialPlay') {
    context.metrics.track(TRACKING_EVENT, {link: `${BASE_TRACKING_LINK_NAME} Video Play Clicked`});
    return;
  }

  if (eventName === 'play') {
    context.metrics.track(TRACKING_EVENT, {link: `${BASE_TRACKING_LINK_NAME} Video Play Start`});
    return;
  }

  if (eventName.indexOf('error') > -1) {
    if (response && response.code === 'unplayable_content') {
      context.metrics.track(TRACKING_EVENT, {link: `${BASE_TRACKING_LINK_NAME} Video Play Fail - Video Missing`});
      return;
    }

    context.metrics.track(TRACKING_EVENT, {link: `${BASE_TRACKING_LINK_NAME} Video Play Fail - Playback Error`});
  }
}

export default makePlayerEventTracker;



// WEBPACK FOOTER //
// ./modules/Ooyala/component/playerEventsTracker.js